import type { JobResponseType } from '../components/Jobs/types';

export const getStatus = (job: JobResponseType | null) => {
    if (job === null) {
        return -1;
    }
    // return job.process_status;
    return job.process_stage;
    // return job.coords_accepted===true && job.target_date!==null ? 1 : 0
};
